(function ($) {

    "use strict";

    $.enhancer("modalHelper", function (el) {

        function clearForm() {

            $("#contact-form-submit").removeClass("d-none");
            $("#form-sent-close-modal").removeClass("d-none");
            $("#form-sent").addClass("d-none");
            $("#form-sent").removeClass("d-flex");
            $("#contact-form").removeClass("invisible");
            $("#contact-form").find("input[type=text], textarea").val("");
        }

        function onFormSubmit() {
            var name = $("#validationName").val();
            var email = $("#validationEmail").val();
            var telephone = $("#phoneNumberNovalidate").val();
            var message = $("#enquiryTextarea").val();

            var url = "PostForm?name={name}&email={email}&telephone={telephone}&message={message}".replace("{name}", name).replace("{email}", email).replace("{telephone}", telephone).replace("{message}", message);


            $.ajax({
                url: url,
                dataType: "html",
                timeout: 15000,
                success: function (data) {
                    $("#form-sent").removeClass("d-none");
                    $("#form-sent").addClass("d-flex");

                },
                complete: function () {
                    $("#contact-form-submit").addClass("d-none");
                    $("#form-sent-close-modal").removeClass("d-none");

                    $("#contact-form").addClass("invisible");
                    $("#contact-form").removeClass("was-validated");

                },
                error: function (xhr, status, error) {
                    $("#form-error").removeClass("d-none");
                    $("#form-error").addClass("d-flex");
                    console.log("Ooops! Något gick fel i searchHandler");
                }
            });
    
            
            

        }
        
        $("#contact-form-submit").on("click", function (e) {
            var form = $("#contact-form")[0];
            var isValid = form.checkValidity();
            if (!isValid) {
                e.preventDefault();
                e.stopPropagation();
            }
            form.classList.add('was-validated');
        })

        $("#contact-form").submit(function (e) {
            e.preventDefault();
            onFormSubmit();
        });

        $('#modalToggle').click(function () {
            $("#contact-modal").modal("show");
        });

        $("#form-sent-close-modal").click(function () {
            clearForm();
        });
        $("#dismiss-modal").click(function () {
            if ($("#form-sent").hasClass("d-flex")) {
                clearForm();
            }
        });


    });

})(jQuery);